import { COPYRIGHT_TEXT } from "@/utils/constants/constants";

const Footer: React.FC = () => {
    return (
        <div className="page_footer">
            <div className="">
                <p className="text-center text-gray-color" id='footer'>
                    {COPYRIGHT_TEXT}
                </p>
            </div>
        </div>
    );
};

export default Footer;
